import { Module } from 'vuex';
import RootState from '../../state';
import { listItemUsingPOST, dispatcherNumUsingPOST } from '@services/goods/item-dispatch-controller';
import { IDispatchItemPageParam, IDispatchItemListVO, IDispatchItemVO, IDispatcherNumVO } from '@services/goods/models';
// import { IDispatchItemPageParam, IDispatchItemListVO, IDispatchItemVO } from '../../../../services/goods/models';
interface ICarState {
    carSubmitParams: IDispatchItemPageParam;
    carGoodsList: IDispatchItemPageParam[];
    pageTotal: number;
    allCount: number;
    bindingCarCount: number;
    invalidCount: number;
}

const intialState = {
    carSubmitParams: {} as IDispatchItemPageParam,
    carGoodsList: [] as IDispatchItemPageParam[],
    pageTotal: 0,
    allCount: 0,
    bindingCarCount: 0,
    invalidCount: 0,
};

const carStore: Module<ICarState, RootState> = {
    namespaced: true,
    state: intialState,
    mutations: {
        setCarGoodsData(state: typeof intialState, { items, total }) {
            state.carGoodsList = items || [];
            state.pageTotal = total || 0;
        },
        setCarSubmitParams(state: typeof intialState, payload: IDispatchItemPageParam) {
            state.carSubmitParams = payload;
        },
        setCarGoodsCount(state: typeof intialState, data: IDispatcherNumVO) {
            state.allCount = data.all;
            state.bindingCarCount = data.caring;
            state.invalidCount = data.invalidation;
        },
    },
    actions: {
        async getCarGoodsData({ commit, dispatch, state, rootState }, payload) {
            const { data } = await listItemUsingPOST({
                param: {
                    ...payload,
                },
            });
            const { items, total } = data;
            commit('setCarGoodsData', { items, total });
        },
        async getCarGoodsCount({ commit, dispatch, state, rootState }, payload) {
            const { data } = await dispatcherNumUsingPOST({
                param: {
                    ...payload,
                },
            });
            commit('setCarGoodsCount', data);
        },
    },
    getters: {},
};

export default carStore;
